import { render } from "./skeleton.vue?vue&type=template&id=dabf6560"
import script from "./skeleton.vue?vue&type=script&lang=js"
export * from "./skeleton.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./skeleton.vue?vue&type=style&index=0&id=dabf6560&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__